module.exports = __webpack_public_path__ + "img/chz-logo.8eaa6791.svg";